var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAuthorized)?_c('router-view'):_c('k-unauthorized')],1)}
var staticRenderFns = []

export { render, staticRenderFns }